<script setup>
import { computed } from 'vue';
import ContactPanel from 'dashboard/routes/dashboard/conversation/ContactPanel.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useWindowSize } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';
import wootConstants from 'dashboard/constants/globals';

defineProps({
  currentChat: {
    required: true,
    type: Object,
  },
});

const { uiSettings, updateUISettings } = useUISettings();
const { width: windowWidth } = useWindowSize();

const activeTab = computed(() => {
  const { is_contact_sidebar_open: isContactSidebarOpen } = uiSettings.value;

  if (isContactSidebarOpen) {
    return 0;
  }
  return null;
});

const isSmallScreen = computed(
  () => windowWidth.value < wootConstants.SMALL_SCREEN_BREAKPOINT
);

const closeContactPanel = () => {
  updateUISettings({
    is_contact_sidebar_open: false,
    is_copilot_panel_open: false,
  });
};
</script>

<template>
  <div
    v-on-click-outside="[
      () => closeContactPanel(),
      {
        ignore: [
          'dialog.ProseMirror-prompt-backdrop',
          '[data-popover-content]',
          '[data-popover-backdrop]',
          '.conversation-header-toggle-area',
        ],
      },
    ]"
    class="relative bg-white dark:bg-[#1C1C1E] h-[calc(100%-2rem)] my-4 mr-4 overflow-hidden flex flex-col w-[320px] min-w-[320px] border !border-slate-100 dark:!border-[#27282D] rounded-2xl shadow-lg transition-all duration-300 ease-in-out"
    :class="[
      {
        'flex': activeTab === 0,
        'hidden': activeTab !== 0,
      },
    ]"
  >
    <!-- Floating Close Button -->
    <button
      type="button"
      class="absolute top-3 right-3 text-n-slate-11 hover:text-n-slate-12 z-50 p-1 cursor-pointer transition-colors"
      @click="closeContactPanel"
    >
      <span class="i-lucide-x size-4.5" />
    </button>

    <div class="flex flex-grow overflow-auto">
      <ContactPanel
        v-show="activeTab === 0"
        :conversation-id="currentChat.id"
        :inbox-id="currentChat.inbox_id"
      />
    </div>
  </div>
</template>
